import React, { useCallback } from 'react'
import { useGetLocationUrl } from '@user/store/authorization/hooks/useGetLocationUrl'
import Typography, { type TypographyProps } from '@mui/material/Typography'
import LaunchIcon from '@mui/icons-material/Launch'
import Button from '@mui/material/Button'
import { Theme } from '@mui/material/styles'

type Props = {
  externalLocationId: string
  externalLocationCode: string
  billingLocation: boolean
  containerSx?: object
  typographyVariant?: TypographyProps['variant']
  fontSize?: string
  label?: string
  noIcon?: boolean
  noLabel?: boolean
  linkButtonSx?: object
}

export function LocationLink({
  externalLocationId,
  externalLocationCode,
  billingLocation,
  containerSx,
  typographyVariant = 'subtitle3',
  fontSize = '13px',
  label = 'Location:',
  noIcon = false,
  noLabel = false,
  linkButtonSx = {},
}: Props) {
  const locationUrl = useGetLocationUrl(externalLocationId, billingLocation)

  const onExternalLocationClick = useCallback(() => {
    if (locationUrl) {
      window.open(locationUrl, '_blank')
    }
  }, [locationUrl])

  return (
    <Typography
      variant={typographyVariant}
      fontSize={fontSize}
      sx={{
        display: 'flex',
        alignItems: 'center',
        fontWeight: '500',
        ...containerSx,
      }}
    >
      {!noLabel && label}
      <Button
        color="primary"
        variant="text"
        size="small"
        onClick={onExternalLocationClick}
        sx={{
          color: '#1565C0',
          fontWeight: '500',
          ...linkButtonSx,
        }}
        disableElevation
      >
        {externalLocationCode}
        {noIcon ? null : (
          <LaunchIcon
            sx={{
              marginLeft: (theme: Theme) => theme.spacing(0.8),
              fontSize: '18px',
              fontWeight: '500',
            }}
          />
        )}
      </Button>
    </Typography>
  )
}
